import AuthLayout from "@/components/layouts/AuthLayout";
import ResetPassword from "@/panel/auth/ResetPassword";
import { useNavigate, useSearchParams } from "react-router";

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") || undefined;

  const onVerified = () => {
    navigate("/dashboard");
  };

  return (
    <AuthLayout>
      <ResetPassword email={email} />
    </AuthLayout>
  );
}
